export const getCart = () => {
    const cart = sessionStorage.getItem('cart');
    return cart ? JSON.parse(cart) : [];
  };
  
  export const setCart = (cart) => {
    sessionStorage.setItem('cart', JSON.stringify(cart));
  };
  
  export const clearCart = () => {
    sessionStorage.removeItem('cart');
  };
  
  export const addItemToCart = (item) => {
    const cart = getCart();
    const itemKey = `${item.id}-${item.color}-${item.size}`;
  
    const existingItem = cart.find(cartItem => `${cartItem.id}-${cartItem.color}-${cartItem.size}` === itemKey);
  
    if (existingItem) {
      existingItem.quantity += item.quantity;
    } else {
      item.addedDate = new Date().getTime();
      cart.push(item);
    }
    
    console.log(cart)
    setCart(cart);
  };
  
  export const removeItemFromCart = (id, color, size) => {
    let cart = getCart();
    cart = cart.filter(item => !(item.id === id && item.color === color && item.size === size));
    setCart(cart);
  };
  
  export const updateItemQuantity = (id, color, size, quantity) => {
    const cart = getCart();
    const item = cart.find(cartItem => cartItem.id === id && cartItem.color === color && cartItem.size === size);
  
    if (item) {
      item.quantity = quantity;
    }
  
    setCart(cart);
  };
  
  export const removeExpiredItems = () => {
    const cart = getCart();
    const currentTime = new Date().getTime();
    const updatedCart = cart.filter(item => currentTime - item.addedDate < 7 * 24 * 60 * 60 * 1000);
  
    setCart(updatedCart);
  };
  
  export const getTotalItems = () => {
    const cart = getCart();
    return cart.reduce((acc, item) => acc + item.quantity, 0);
  };
  